// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_account_account_module_ts":"6121e45e210be6c5","src_app_checkout_checkout_module_ts":"f119c4f0b4b79791","node_modules_photoswipe_dist_photoswipe_esm_js":"b73763a4059bf0eb"}[chunkId] + ".js";
};